import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import API from '../utils/api';

const API_BASE = process.env.REACT_APP_API_URL?.replace('/api', '') || '';
const CATEGORIES = ['all', 'cows', 'activities', 'festivals', 'infrastructure', 'events'];
const CATEGORY_KEYS = { all: 'categoryAll', cows: 'categoryCows', activities: 'categoryActivities', festivals: 'categoryFestivals', infrastructure: 'categoryInfrastructure', events: 'categoryEvents' };

export default function Gallery() {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState('all');
  const [lightbox, setLightbox] = useState(null);
  const [typeFilter, setTypeFilter] = useState('all');

  useEffect(() => {
    const q = new URLSearchParams();
    q.set('placement', 'gallery');
    if (category !== 'all') q.set('category', category);
    if (typeFilter !== 'all') q.set('type', typeFilter);
    API.get(`/gallery?${q}`).then(r => { setItems(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, [category, typeFilter]);

  const getUrl = item => item.url?.startsWith('http') ? item.url : `${API_BASE}${item.url}`;

  return (
    <div>
      <div className="page-header">
        <h1>{t('gallery.pageTitle')}</h1>
        <p>{t('gallery.pageSubtitle')}</p>
      </div>

      {/* Lightbox */}
      {lightbox && (
        <div onClick={() => setLightbox(null)} style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.92)', zIndex: 9999,
          display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, cursor: 'pointer'
        }}>
          {lightbox.type === 'video'
            ? <video src={getUrl(lightbox)} controls autoPlay style={{ maxWidth: '90vw', maxHeight: '85vh', borderRadius: 12 }} onClick={e => e.stopPropagation()} />
            : <img src={getUrl(lightbox)} alt={lightbox.title} style={{ maxWidth: '90vw', maxHeight: '85vh', borderRadius: 12, objectFit: 'contain' }} />
          }
          <div style={{ position: 'absolute', top: 20, right: 20, color: '#fff', fontSize: '2rem', cursor: 'pointer', background: 'rgba(0,0,0,0.5)', borderRadius: '50%', width: 44, height: 44, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>✕</div>
          {lightbox.title && (
            <div style={{ position: 'absolute', bottom: 20, left: '50%', transform: 'translateX(-50%)', color: '#fff', background: 'rgba(0,0,0,0.7)', padding: '8px 20px', borderRadius: 8 }}>
              {lightbox.title}
            </div>
          )}
        </div>
      )}

      <section className="section">
        <div className="container">
          {/* Filters */}
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 12 }}>
            {CATEGORIES.map(c => (
              <button key={c} className={`btn btn-sm${category === c ? ' btn-primary' : ' btn-outline'}`} onClick={() => setCategory(c)} style={{ textTransform: 'capitalize' }}>
                {t(`gallery.${CATEGORY_KEYS[c]}`)}
              </button>
            ))}
          </div>
          <div style={{ display: 'flex', gap: 10, marginBottom: 32 }}>
            {['all', 'image', 'video'].map(tf => (
              <button key={tf} className={`btn btn-sm${typeFilter === tf ? ' btn-green' : ' btn-outline'}`} onClick={() => setTypeFilter(tf)} style={{ textTransform: 'capitalize' }}>
                {tf === 'all' ? t('gallery.typeAll') : tf === 'image' ? t('gallery.typePhotos') : t('gallery.typeVideos')}
              </button>
            ))}
          </div>

          {loading ? (
            <div className="loader"><div className="spinner" /></div>
          ) : items.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '60px 0', color: '#888' }}>
              <div style={{ fontSize: '4rem', marginBottom: 12 }}>📸</div>
              <p>{t('gallery.noItems')}</p>
            </div>
          ) : (
            <div className="gallery-grid">
              {items.map(item => (
                <div key={item._id} className="gallery-item" onClick={() => setLightbox(item)}>
                  {item.type === 'video'
                    ? (
                      <div style={{ position: 'relative' }}>
                        <video src={getUrl(item)} style={{ width: '100%', height: 220, objectFit: 'cover', display: 'block' }} />
                        <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.3)' }}>
                          <span style={{ fontSize: '3rem' }}>▶️</span>
                        </div>
                      </div>
                    )
                    : <img src={getUrl(item)} alt={item.title} />
                  }
                  <div className="gallery-item-overlay">
                    <span className="gallery-item-title">{item.title}</span>
                  </div>
                  {item.type === 'video' && (
                    <div style={{ position: 'absolute', top: 8, right: 8, background: 'var(--saffron)', color: '#fff', padding: '2px 8px', borderRadius: 4, fontSize: '0.75rem', fontWeight: 600 }}>{t('gallery.videoBadge')}</div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
